// extracted by mini-css-extract-plugin
export default {"certificationBannerContainer":"XKVocvcZ","inner":"QUjXN_uM","sharedText":"ND85AZS8","mortar":"e8TeDXcu","left":"EvvAR13k","title":"A3fp5yC7","right":"FerwYRiS","arrow":"ofpsCWFm"};